import { Modal } from 'antd';

import './styles.scss';

export default function CustomModal(props) {
	return <Modal  {...props}></Modal>;
}
